import React, {Component} from 'react';
import PropTypes from 'prop-types'

import {withStyles} from 'material-ui/styles';
import {ListItem, ListItemText} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Tooltip from 'material-ui/Tooltip';

const styles = {
  item: {
    paddingLeft: 12,
    paddingRight: 12,
    backgroundColor: '#f1f1f1'
  },
  avatar: {
    border: '1px solid #d4d4d4',
    backgroundColor: '#fff'
  },
  avatarImg: {
    width: '130%',
    maxWidth: '130%',
    paddingTop: 10
  },
  text: {
    fontSize: '12px',
    lineHeight: '20px'
  }
};

class PlayerListItem extends Component {

  componentDidMount() {
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.player !== this.props.player;
  }

  render() {
    const p = this.props.player;
    const classes = this.props.classes;

    const hover = (
      <div style={{width: 40, whiteSpace: 'wrap', lineHeight: 1.2, textAlign: 'center', padding: '4px 0'}}>
        <small>{p.name}</small>
      </div>
    );

    return (
      <ListItem button onClick={() => this.props.onClick(p)} className={classes.item}>
        <Tooltip title={hover} enterDelay={800}>
          <Avatar
            classes={{
              root: classes.avatar,
              img: classes.avatarImg,
            }}
            className={classes.avatar}
            alt={p.name}
            src={`//static.nhle.com/mugs/mlbam/${p.id}@2x.png`}/>
        </Tooltip>
        <ListItemText className={classes.text} primary={p.name} secondary={p.team.name}/>
      </ListItem>
    )
  };
}

PlayerListItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  player: PropTypes.object.isRequired
};

export default withStyles(styles)(PlayerListItem)


// WEBPACK FOOTER //
// ./src/components/PlayerListItem.js